import {MuWidget} from "mu-widget/lib/MuWidget";
import {UiDms} from "./UiDms";
import {DmsAttach, DmsDocument} from "./Types";
import {MultiUpload} from "../MultiUpload";
import {ColumnInfo, UiTable} from "../components/UiTable";
import {TCFormatDate} from "../Utils";

export class UiDmsAttaches extends MuWidget
{
	// @ts-ignore
	public dmsDocumentId: number;
	private dmsDocument: DmsDocument;
	// @ts-ignore
	private downloadLink: string;
	private currentDmsAttach: DmsAttach | null = null;
	private onSaved: ((value: any) => void)|null = null;
	private savedPromise: Promise<any> | null = null;

	public inCreateForm: boolean = false;

	beforeIndex() {
		this.muAppendContent(`
			<div class="dms-attaches__list-preview" mu-id="listPreview" mu-keybind="Escape:btCloseModal">
				<div>
					<label mu-id="pShowInvalidated"><input type="checkbox" mu-id="chShowInvalidated" />Zobrazit zneplatněné</label>
					<div mu-id="types" mu-bind="types::@foreach" class="dms-attaches__list">
						<fieldset mu-widget="UiDmsAttachesType" mu-template="item" mu-bind="attachTypeId:.attachTypeId">
							<legend mu-bind="name"></legend>
							<!-- <div mu-bind="attaches:@foreach">
								<div mu-widget="UiDmsAttachesAttach" mu-template="item" class="dms-attaches__list-item">
									<span mu-bind='dtCreated|dateTime("d.m.Y");dtCreated|dateTime("d.m.Y H:i"):title'></span>
									<span class="icon-document-html"></span>
									<strong mu-bind='fileName; dtInvalidation|tern("dms-attaches__list-item--invalidated", "")|append(" a"):className' mu-id="fileName" class="a"></strong>
								</div>
							</div> -->
							<table class="table" mu-id="attaches" mu-widget="UiTable"></table>
							<div mu-id="mupNewAttach" mu-widget="MultiUpload"></div>
						</fieldset>
					</div>
				</div>
				<div class="dms-attaches__preview">
					<h3 class="display-flex-row dms-attaches__preview__title">
						<span class="flex-grow-1">Náhled <span mu-id="previewFileName"></span></span>
						<span class="icon-trash icon-24 cursor-pointer" mu-id="bInvalidate" title="Zneplatnit"></span>
						<span class="icon-download icon-24 cursor-pointer" mu-id="bDownload" title="Stáhnout"></span>
						<span class="icon-close icon-24 cursor-pointer" mu-id="bClosePreview"></span>
					</h3>
					<div class="loading-data dms-attaches__preview__content" mu-id="pPreviewContent"></div>
					<div class="alert alert-danger" mu-template="previewFailed">Nepodařilo se vygenerovat náhled. stáhněte dokument do svého zařízení</div>
					<div class="dms-attaches__preview__notice alert alert-warning" mu-id="previewNotice"></div>
				</div>
			</div>
			<div class="buttons" mu-id="pSaveButton">
				<span class="btn btn-primary" mu-id="bAddDocuments">Přidat dokumenty</span>
			</div>
		`);
	}

	public async reload() {
		await this.showForDmsDocument(this.dmsDocument);
	}

	afterIndex() {
		this.muVisible(!this.inCreateForm, [ "pSaveButton", "pShowInvalidated" ]);
	}

	public async showForDmsDocument(dmsDocument: DmsDocument) {
		this.container.classList.add('loading-data');
		this.dmsDocumentId = dmsDocument.id;
		this.dmsDocument = dmsDocument;
		const allAttachTypes = await UiDms.instance.cpDmsAttachType.fetch();
		const byTypes: Record<number, any> = {};
		const documentTypeOpts = dmsDocument.dmsDocumentTypeId.opts;
		const newTypeGroup = (attachType: any) => {
			if (typeof attachType === "number") attachType = allAttachTypes.find((at:any) => at.id == attachType);
			return {
				name: attachType.name,
				attachTypeId: attachType.id,
				attaches: []
			}
		};
		for(const attachType of allAttachTypes) {
			if (documentTypeOpts.attachTypes && !documentTypeOpts.attachTypes.includes(attachType.code)) continue;
			byTypes[attachType.id] = newTypeGroup(attachType);
		}

		if (dmsDocument.id) {
			const filter = {
				showInvalidated: this.ui.chShowInvalidated.checked,
				dmsDocumentId: dmsDocument.id
			}
			for(const dAttach of await UiDms.instance.cl.getAllDmsAttaches(filter))
			{
				if (!byTypes[dAttach.dmsAttachTypeId]) byTypes[dAttach.dmsAttachTypeId] = newTypeGroup(dAttach.dmsAttachTypeId);
				byTypes[dAttach.dmsAttachTypeId].attaches.push(dAttach);
			}
		}

		this.muBindData({ types: Object.values(byTypes) });

		this.container.classList.remove('loading-data');
	}

	async bAddDocuments_click() {
		return await this.doSaveAttaches();
	}
	public async doSaveAttaches() {
		let attaches: any[] = [];
		for(const type of this.muGetChildWidgets<UiDmsAttachesType>("types"))
		{
			const typeRes = await (type.muNamedWidget.mupNewAttach as unknown as MultiUpload).sendToBackend(async (context, send) => {
				context.url = await UiDms.instance.cl.newTempFile();
				context.dmsAttachTypeId = type.attachTypeId;
				send();
			});
			attaches = [ ...attaches, ...typeRes.map(uc => <any>{
				dmsAttachTypeId: uc.dmsAttachTypeId,
				fileName: uc.file.name,
				fileContentType: uc.file.type,
				dmsDocumentId: this.dmsDocumentId,
				tmpName: uc.url,
			}) ];
		}
		// console.log(attaches);
		await UiDms.instance.cl.saveAllAttaches(attaches);
		await Promise.all([
			this.reload(),
			UiDms.instance.muNamedWidget.documents.loadList(),
		]);
		if (this.onSaved) this.onSaved(null);
	}

	bClosePreview_click() {
		this.openPreview(null);
	}

	bDownload_click() {
		window.open(this.downloadLink, '_blank');
	}

	async bInvalidate_click() {
		if (confirm('Opravdu chcete zneplatnit přílohu?')) {
			// @ts-ignore
			await UiDms.instance.cl.invalidateDmsAttach(this.currentDmsAttach.id);
			await Promise.all([
				this.reload(),
				UiDms.instance.muNamedWidget.documents.loadList(),
			]);
		}
	}

	public async openPreview(attach: DmsAttach | null): Promise<void> {
		this.currentDmsAttach = attach;
		this.ui.listPreview.classList.toggle("dms-attaches__list-preview--with-preview", !!attach);
		this.container.classList.toggle('dms-attaches__modal', !!attach);
		if (attach) {
			this.ui.pPreviewContent.classList.toggle('loading-data', true);
			this.ui.previewFileName.innerText = attach.fileName;
			this.downloadLink = attach.downloadLink;
			try {
				const previewData = await UiDms.instance.cl.getDmsAttachPreview(attach.id);
				this.ui.pPreviewContent.innerHTML = previewData.content;
				this.muVisible(!!previewData.notice, 'previewNotice');
				this.ui.previewNotice.innerText = previewData.notice || "";
				// this.downloadLink = previewData.downloadLink;
			} catch (exc) {
				this.ui.pPreviewContent.innerHTML = this.muTemplates.previewFailed;
			} finally {
				this.ui.pPreviewContent.classList.toggle('loading-data', false);
			}
		}
	}

	chShowInvalidated_change() {
		this.reload();
	}

	newSavedPromise(): Promise<any> {
		this.savedPromise = new Promise(resolve => { this.onSaved = resolve });
		return this.savedPromise;
	}
}
export class UiDmsAttachesType extends MuWidget<UiDmsAttaches> {
	// @ts-ignore
	public attachTypeId: number;

	muBindData(srcData: any) {
		super.muBindData(srcData);
		const table = this.muNamedWidget.attaches as unknown as UiTable;
		table.columns = [
			new ColumnInfo({ field: "dtCreated", name: "Přidáno", orderable: false, filterable: false, transformContent: TCFormatDate }),
			new ColumnInfo({ field: "fileName", name: "Název", orderable: false, filterable: false }),
			new ColumnInfo({ field: "accountCreated", name: "Přidal", orderable: false, filterable: false }),
		];
		table.data = srcData.attaches;
		table.render();
	}

	attaches_rowClick(ev:any, wRow:any) {
		this.muParent.openPreview(wRow.data);
	}

	attaches_rowRendered(ev:any, wRow:any) {
		wRow.container.classList.toggle("dms-attaches__list-item--invalidated", !!wRow.data.dtInvalidation);
	}
}

export class UiDmsAttachesAttach extends MuWidget {
	// @ts-ignore
	public dmsAttach: DmsAttach;

	fileName_click() {
		(this.muParent.muParent as UiDmsAttaches).openPreview(this.dmsAttach);
	}

	muBindData(srcData: any) {
		super.muBindData(srcData);
		this.dmsAttach = srcData;
	}
}